import React from "react";
import Wrapper from "./Search.styled";
// import icons
import { Icon } from "@iconify/react";

function Search({
  type,
  placeholder,
  onFocus,
  onBlur,
  searchValue,
  onChange,
  className,
  setSearchValue,
}) {
  return (
    <Wrapper>
      <label htmlFor="search">
        <Icon icon="fe:search" className="  mb-2" />
      </label>
      <input
        id="search"
        type={type}
        placeholder={placeholder}
        onFocus={onFocus}
        onBlur={onBlur}
        value={searchValue}
        onChange={onChange}
        // onChange={(e) => setSearchValue(e.target.value)}
        className={className}
      />
    </Wrapper>
  );
}

export default Search;
